<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Page</span></p>
<p><a href="#/c003">DEDICATION</a></p>
<p><span href="#/c004" title="Link target outside of Sample">Ring of Ice (Frost Worlds/Pulse)</span></p>
<p><span href="#/c005" title="Link target outside of Sample">Meet Kailin Gow</span></p>
<p><span href="#/c006" title="Link target outside of Sample">Get all the books in the Bitter Frost Series | Bitter Frost</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Forever Frost</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Silver Frost</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Frost Kisses</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Midnight Frost</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Frost Fire</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Spring Frost</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Enchanted Frost</span></p>
<p><span href="#/c014" title="Link target outside of Sample">The PULSE Vampires Series | PULSE</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Life’s Blood</span></p>
<p><span href="#/c016" title="Link target outside of Sample">Blood Burned</span></p>
<p><span href="#/c017" title="Link target outside of Sample">Blue Blood</span></p>
<p><span href="#/c018" title="Link target outside of Sample">Blood Bond</span></p>
<p><span href="#/c019" title="Link target outside of Sample">Blood Legacy</span></p>
<p><span href="#/c020" title="Link target outside of Sample">Blood Rights</span></p>
<p><span href="#/c021" title="Link target outside of Sample">Blood Curse</span></p>
<p><span href="#/c022" title="Link target outside of Sample">Blood Ring</span></p>
<p><span href="#/c023" title="Link target outside of Sample">Brotherhood of Blood</span></p>
<p><span href="#/c024" title="Link target outside of Sample">or | PULSE Omnibus 1</span></p>
<p><span href="#/c025" title="Link target outside of Sample">PULSE Omnibus 2</span></p>
<p><span href="#/c026" title="Link target outside of Sample">Ring of Ice (Frost Worlds/Pulse)</span></p>
<p><span href="#/c027" title="Link target outside of Sample">THANK YOU!</span></p>
<p><span href="#/c028" title="Link target outside of Sample">Love the Bitter Frost Series and want more? | Get the Prequel Novella about the Bitter Frost Series | For Free Here: | https://BookHip.com/VJMPXA</span></p>
<p><span href="#/other.new_release_sign_up_page" title="Link target outside of Sample">Sign up for Kailin Gow's Mailing List</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?768c6c32